import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { JobStatus } from '../constants/status';
import { unwrapCallableData } from './callableResponse';

interface CancelJobRequest {
  companyId: string;
  jobId: string;
}

interface CancelJobResponse {
  companyId: string;
  jobId: string;
  status: JobStatus;
  cancelled?: number;
}

const cancelJob = async (payload: CancelJobRequest): Promise<CancelJobResponse> => {
  const fn = httpsCallable<CancelJobRequest, CancelJobResponse>(
    functions,
    'handle_cancel_job',
  );

  const result = await fn(payload);
  return unwrapCallableData<CancelJobResponse>(result.data);
};

export { cancelJob };
